import {Button as $36a99e6d76bd9d26$export$353f5b6fc5456de1} from "../button/Button.mjs";
import {ButtonGroup as $3a97ced4c1581335$export$69b1032f2ecdf404} from "../buttongroup/ButtonGroup.mjs";
import {classNames as $6e6392558d48dfec$export$ce4ab0c55987d1ff} from "../utils/classNames.mjs";
import {Content as $b579958ab95f14cb$export$7c6e2c02157bb7d2} from "../view/Content.mjs";
import {Dialog as $8054558191a4f1c9$export$3ddf2d174ce01153} from "./Dialog.mjs";
import {DialogContext as $45cab99fd43a8f38$export$8b93a07348a7730c} from "./context.mjs";
import {Divider as $722c0b5bc0afb38c$export$2e0a83ec2e27ecbb} from "../divider/Divider.mjs";
import {Heading as $31107baeb31b7fac$export$a8a3e93435678ff9} from "../text/Heading.mjs";
import $lhEz1$intlStringsmjs from "./intlStrings.mjs";
import "../dialog_vars.css";
import $lhEz1$dialog_vars_cssmjs from "../dialog_vars_css.mjs";
import {useStyleProps as $63d03c54ca5e4b88$export$b8e6fb9d2dff3f41} from "../utils/styleProps.mjs";
import $lhEz1$spectrumiconsuiAlertMedium from "@spectrum-icons/ui/AlertMedium";
import {chain as $lhEz1$chain} from "react-aria/chain";
import {filterDOMProps as $lhEz1$filterDOMProps} from "react-aria/filterDOMProps";
import $lhEz1$react, {forwardRef as $lhEz1$forwardRef, useContext as $lhEz1$useContext} from "react";
import {useLocalizedStringFormatter as $lhEz1$useLocalizedStringFormatter} from "react-aria/useLocalizedStringFormatter";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 















const $e2979e34515e88d9$export$de466dd8317b0b75 = /*#__PURE__*/ (0, $lhEz1$forwardRef)(function AlertDialog(props, ref) {
    let { onClose: onClose = ()=>{} } = (0, $lhEz1$useContext)((0, $45cab99fd43a8f38$export$8b93a07348a7730c)) || {};
    let { variant: variant, children: children, primaryActionLabel: primaryActionLabel, secondaryActionLabel: secondaryActionLabel, cancelLabel: cancelLabel, autoFocusButton: autoFocusButton, title: title, isPrimaryActionDisabled: isPrimaryActionDisabled, isSecondaryActionDisabled: isSecondaryActionDisabled, onCancel: onCancel = ()=>{}, onPrimaryAction: onPrimaryAction = ()=>{}, onSecondaryAction: onSecondaryAction = ()=>{}, ...otherProps } = props;
    let { styleProps: styleProps } = (0, $63d03c54ca5e4b88$export$b8e6fb9d2dff3f41)(otherProps);
    let stringFormatter = (0, $lhEz1$useLocalizedStringFormatter)((0, ($parcel$interopDefault($lhEz1$intlStringsmjs))), '@react-spectrum/dialog');
    let confirmVariant = 'primary';
    if (variant) {
        if (variant === 'confirmation') confirmVariant = 'cta';
        else if (variant === 'destructive') confirmVariant = 'negative';
    }
    return /*#__PURE__*/ (0, $lhEz1$react).createElement((0, $8054558191a4f1c9$export$3ddf2d174ce01153), {
        UNSAFE_style: styleProps.style,
        UNSAFE_className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($lhEz1$dialog_vars_cssmjs))), {
            [`spectrum-Dialog--${variant}`]: variant
        }, styleProps.className),
        isHidden: styleProps.hidden,
        size: "M",
        role: "alertdialog",
        ref: ref,
        ...(0, $lhEz1$filterDOMProps)(props)
    }, /*#__PURE__*/ (0, $lhEz1$react).createElement((0, $31107baeb31b7fac$export$a8a3e93435678ff9), null, title), (variant === 'error' || variant === 'warning') && /*#__PURE__*/ (0, $lhEz1$react).createElement((0, $lhEz1$spectrumiconsuiAlertMedium), {
        slot: "typeIcon",
        "aria-label": stringFormatter.format('alert')
    }), /*#__PURE__*/ (0, $lhEz1$react).createElement((0, $722c0b5bc0afb38c$export$2e0a83ec2e27ecbb), null), /*#__PURE__*/ (0, $lhEz1$react).createElement((0, $b579958ab95f14cb$export$7c6e2c02157bb7d2), null, children), /*#__PURE__*/ (0, $lhEz1$react).createElement((0, $3a97ced4c1581335$export$69b1032f2ecdf404), {
        align: "end"
    }, cancelLabel && /*#__PURE__*/ (0, $lhEz1$react).createElement((0, $36a99e6d76bd9d26$export$353f5b6fc5456de1), {
        variant: "secondary",
        onPress: ()=>(0, $lhEz1$chain)(onClose(), onCancel()),
        autoFocus: autoFocusButton === 'cancel',
        "data-testid": "rsp-AlertDialog-cancelButton"
    }, cancelLabel), secondaryActionLabel && /*#__PURE__*/ (0, $lhEz1$react).createElement((0, $36a99e6d76bd9d26$export$353f5b6fc5456de1), {
        variant: "secondary",
        onPress: ()=>(0, $lhEz1$chain)(onClose(), onSecondaryAction()),
        isDisabled: isSecondaryActionDisabled,
        autoFocus: autoFocusButton === 'secondary',
        "data-testid": "rsp-AlertDialog-secondaryButton"
    }, secondaryActionLabel), /*#__PURE__*/ (0, $lhEz1$react).createElement((0, $36a99e6d76bd9d26$export$353f5b6fc5456de1), {
        variant: confirmVariant,
        onPress: ()=>(0, $lhEz1$chain)(onClose(), onPrimaryAction()),
        isDisabled: isPrimaryActionDisabled,
        autoFocus: autoFocusButton === 'primary',
        "data-testid": "rsp-AlertDialog-confirmButton"
    }, primaryActionLabel)));
});


export {$e2979e34515e88d9$export$de466dd8317b0b75 as AlertDialog};
//# sourceMappingURL=AlertDialog.mjs.map
